<template>
  <el-card>
    <MessageAdd :userType="userType" ref="newMessage" />
    <MessageRead ref="readMessage" />
    <div slot="header" class="clearfix">
      <el-col :lg="12">
        <el-link type="primary"><el-checkbox v-model="selection" @change="selectAll"></el-checkbox></el-link>&nbsp;
        <el-link icon="el-icon-refresh-left" @click="fetch" type="primary"></el-link>&nbsp;
        <el-link icon="el-icon-delete" @click="remove" class="text" type="primary">Remover</el-link>&nbsp;
        <el-link icon="el-icon-check" @click="read(true)" class="text" type="primary">Marcar como lida</el-link>&nbsp;
        <el-link icon="el-icon-message" @click="read(false)" class="text" type="primary">Marcar como não
          lida</el-link>&nbsp;
      </el-col>
      <el-col :lg="12" class="right">
        <el-button size="small" icon="el-icon-chat-line-square" class="right" type="primary"
          @click="$refs.newMessage.open()">Nova
          mensagem</el-button>
      </el-col>
    </div>
    <el-row :gutter="5">
      <el-col :sm="24">
        <el-table :data="tableData" stripe ref="tableMessage" size="mini" style="width: 100%" :show-header="false"
          :row-style="rowRead" @row-click="rowClick">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column width="160" prop="userName"></el-table-column>
          <el-table-column sortable prop="message">
            <template slot-scope="scope">
              <i class="el-icon-star-on" v-if="scope.row.highlight" style="color: #f6a306"></i>
              <b class="text" :title="scope.row.message">{{ scope.row.subject }} - </b><span class="text"
                :title="scope.row.message">{{
                  message(scope.row.message)
                }}</span>
            </template>
          </el-table-column>
          <el-table-column width="160" prop="createdAt" label="Imp/Conf"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { NotificationService } from "@/services/comum/notification.services";
import MessageAdd from "./MessageAdd.vue";
import MessageRead from "./MessageRead.vue";
export default {
  props: ["userType"],
  data() {
    return {
      dialog: false,
      selection: false,
      tableData: []
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    open(row) {
      const index = this.tableData.findIndex(x => x.id === row.id);
      this.tableData[index].read = true;
      NotificationService.read([row.id], true);
      this.$bus.$emit("readMessage", 'subtract', 1);
      this.$refs.readMessage.open(row);
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      NotificationService.list(50, 1)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    message(data) {
      return data.length > 60
        ? data.substring(0, 60) + "...."
        : data;
    },
    read(data) {
      const vm = this;
      const list = vm.$refs.tableMessage.selection.map(x => x.id);
      NotificationService.read(list, data);
      for (const row of vm.$refs.tableMessage.selection) {
        row.read = data;
      }
      vm.$bus.$emit("readMessage", 'set', vm.tableData.filter(x => x.read === false).length);
    },
    remove() {
      const vm = this;
      const data = vm.$refs.tableMessage.selection.map(x => x.id);
      if (data.length === 0) {
        return this.$message({
          type: "error",
          message: "Selecione as mensagens para eliminação",
          duration: 5000,
        });
      }
      this.$confirm(i18n.t("confirmar-eliminacao-mensagens"), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        NotificationService.delete(data)
          .then((response) => {
            vm.$emit('delete', data.length);
            vm.fetch();
            this.$message({
              type: "success",
              duration: 5000,
              message: "Mensagens removidas com sucesso!",
            });
            vm.$bus.$emit("readMessage", 'set', vm.tableData.filter(x => x.read === false).length);
            loading.close();
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    rowRead(data) {
      const { row } = data;
      return row.read ? {} : { "font-weight": "bold" };
    },
    // 1 clique abre a mensagem (era só no duplo); o checkbox segue selecionando
    rowClick(row, column) {
      if (column && column.type === "selection") {
        return;
      }
      this.open(row);
    },
    selectAll() {
      if (this.selection) this.$refs.tableMessage.toggleAllSelection();
      else this.$refs.tableMessage.clearSelection();
    },
  },
  components: { MessageAdd, MessageRead }
};
</script>

<style scoped>
.text {
  font-size: 11px;
}

.bold {
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
  min-height: 160px;
  margin: 25px 0;
}
</style>